import { emptyFragment } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { previewStore } from '../../LearningCollection/ChatbotPreview/LearningCollectionPreviewStore';
import FilterContainer from './FilterContainer';
import Filters from './Filters';
import Search from './Search';

interface Props {
  disabled: boolean;
}

function Exploration({ disabled }: Props) {
  const { state } = previewStore;
  switch (state.kind) {
    case 'waiting':
    case 'publishing':
    case 'creating':
    case 'save-and-editing':
    case 'confirming-cancel':
    case 'confirming-cancel-from-publish':
    case 'confirming-cancel-from-create':
    case 'confirming-cancel-from-save-and-edit':
    case 'error':
    case 'loading':
    case 'publish-celebration':
    case 'save-celebration':
    case 'discarding-changes':
      return emptyFragment();
    case 'recommendations-incoming':
    case 'ready':
    case 'saving-from-publishing':
    case 'saving-from-creating':
    case 'saving-from-save-and-editing':
      const { search } = state.resource.payload;
      switch (search) {
        case 'exploration_search':
          return (
            <FilterContainer>
              <Search disabled={disabled} />
            </FilterContainer>
          );
        case 'exploration_search_and_filter':
          return (
            <FilterContainer>
              <Search disabled={disabled} />
              <Filters disabled={disabled} />
            </FilterContainer>
          );
        case 'exploration_filter':
          return <Filters disabled={disabled} />;
        case 'exploration_disable':
          return emptyFragment();
      }
  }
}

export default observer(Exploration);
